import React from 'react';
import ProjectLayout from '../ProjectLayout';
import './ProjectPage.css'; // Custom styles for this project

const references =`
@article{s1_2025,
  author  = {Muennighoff, Niklas and Yang, Zitong and Shi, Weijia and others},
  title   = {s1: Simple test-time scaling},
  journal = {arXiv preprint arXiv:2501.19393},
  year    = {2025},
  url     = {https://arxiv.org/abs/2501.19393},
}

`;

const PreFT = ({ project }) => {
  return (
    <ProjectLayout project={project} className="preft-page" references={references}>
      <h2>Introduction</h2>

      <p>
          Visit the links to see more!
      </p>

      <section className="links-section">
        <h2>Project Links</h2>
        <div className="project-links">
            <a href="https://github.com/stanfordnlp/preft"
            target="_blank"
            rel="noopener noreferrer"
            >
            Code
            </a>
            <a href="https://arxiv.org/abs/2605.14217"
                target="_blank"
                rel="noopener noreferrer"
            >
            arXiv
            </a>
        </div>
      </section>
    </ProjectLayout>
  );
};

export default PreFT;
